import React from 'react';
import './App.css';
import 'rsuite/dist/rsuite-no-reset.min.css';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import LoginPage from './components/LoginPage/LoginPage';
import Register from './components/Register/Register';
import ChooseRole from './components/ChooseRole/ChooseRole';
import TrainerRegister from './components/Register/TrainerRegister';
import ChooseImage from './components/ChooseImage/ChooseImage';
import ResetPassword from './components/ResetPassword/ResetPassword';
import ResetPasswordCode from './components/ResetPassword/ResetPasswordCode';
import Reseting from './components/ResetPassword/Reseting';
import Congratulations from './components/Congratulations/Congratulations';
import Home from './components/Home/Home';
import { CookiesProvider } from 'react-cookie';
import Guard from './components/Guard/Guard';
import Chat from './components/Chat/Chat';
import AddNewChat from './components/Chat/AddNewChat';
import Profile from './components/Profile/Profile';
import ContactUs from './components/ContactUs/ContactUs';
import AdminSidebar from './components/Admin/Common/AdminSidebar';
import Analytics from './components/Admin/pages/Analytics';
import ManageMessage from './components/Admin/pages/ManageMessage';
import ManageAdmins from './components/Admin/pages/ManageAdmins';
import Sales from './components/Admin/pages/Sales';
import MangeUsers from './components/Admin/pages/MangeUsers';
import MangeCategories from './components/Admin/pages/MangeCategories';
import ManageAllUsers from './components/Admin/pages/MangeAllUsers';
import AdminGuard from './components/Guard/AdminGuard';
import About from './components/AboutUs/About';
import MangeContacts from './components/Admin/pages/MangeContacts';
import MessageUser from './components/Admin/pages/MessageUser';
import EnterChat from './components/Admin/pages/EnterChat';
import ChatAdmin from './components/Admin/Analytics/ChatAdmin';

// Conditional Admin Layout
const AdminLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const adminRoutes = ['/analytics',
    '/manage-messages',
    '/admins',
    '/sales',
    '/manage-users',
    '/manage-categories',
    '/manage-trainers',
    '/manage-contacts',
    '/message-user',
    '/enter-chat',];

  return (
    <div className="flex">
      <div className="flex-grow">{children}</div>
      {adminRoutes.includes(location.pathname) && <AdminSidebar />}
    </div>
  );
};

function App() {
  return (
    <div className="overflow-x-hidden">
      <CookiesProvider>
        <BrowserRouter>
          <AdminLayout>
            <Routes>
              <Route path="/" element={<ChooseRole />} />
              <Route path="/home" element={<Guard><Home /></Guard>} />
              <Route path="/about-us" element={<Guard><About /></Guard>} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register/trainerregister" element={<TrainerRegister />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
              <Route path="/congrats" element={<Congratulations />} />
              <Route path="/chat" element={<Guard><Chat /></Guard>} />
              <Route path="/newchat" element={<Guard><AddNewChat /></Guard>} />
              <Route path="/profile/:id" element={<Guard><Profile /></Guard>} />
              <Route path="/contact-us" element={<Guard><ContactUs /></Guard>} />
              <Route path="/otp/:email" element={<ResetPasswordCode />} />
              <Route path="/reset/:email" element={<Reseting />} />
              //admin
              <Route path="/analytics" element={<AdminGuard><Analytics /></AdminGuard>} />
              <Route path="/admins" element={<AdminGuard><ManageAdmins /></AdminGuard>} />
              <Route path="/sales" element={<AdminGuard><Sales /></AdminGuard>} />
              <Route path="/manage-messages" element={<AdminGuard><ManageMessage /></AdminGuard>} />
              <Route path="/manage-users" element={<AdminGuard><ManageAllUsers /></AdminGuard>} />
              <Route path="/manage-trainers" element={<AdminGuard><MangeUsers /></AdminGuard>} />
              <Route path="/manage-categories" element={<AdminGuard><MangeCategories /></AdminGuard>} />
              <Route path="/manage-contacts" element={<AdminGuard><MangeContacts /></AdminGuard>} />
              <Route path="/message-user" element={<AdminGuard><MessageUser /></AdminGuard>} />
              <Route path="/enter-chat" element={<AdminGuard><EnterChat /></AdminGuard>} />
              <Route path="/adminviewchat" element={<AdminGuard><ChatAdmin /></AdminGuard>} />

              <Route path="/register/:role" element={<Register />} />
              <Route path="/userimage/:role" element={<ChooseImage />} />
            </Routes>
          </AdminLayout>
        </BrowserRouter>
      </CookiesProvider>
    </div>
  );
}

export default App;
